export default "__VITE_ASSET__c03502ac__"